import { css } from '@emotion/react'
import { Checkbox, HFlow, Text, Theme, Tooltip, useTheme, VFlow } from 'bold-ui'

import { MCHAT_PERGUNTAS } from '../../mchat/model-mchat'
import { getMChatPerguntaNumber } from '../../mchat/utils-mchat'
import { MChatPerguntaPrincipal } from '../model-consultaSeguimento'
import { ConsultaSeguimentoPerguntaSelectListItemStatus } from './ConsultaSeguimentoPerguntaSelectListItemStatus'

interface ConsultaSeguimentoPerguntaSelectListProps {
  listOfPerguntas: ReadonlyArray<MChatPerguntaPrincipal>
  disabled?: boolean
  disabledTooltipText?: string
  getListItemHasData: (pergunta: MChatPerguntaPrincipal) => boolean
}

export function ConsultaSeguimentoPerguntaSelectList(props: Readonly<ConsultaSeguimentoPerguntaSelectListProps>) {
  const { listOfPerguntas, disabled, disabledTooltipText, getListItemHasData } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <VFlow style={styles.list}>
      {listOfPerguntas.map((pergunta) => (
        <HFlow key={pergunta} alignItems='center' justifyContent='space-between' hSpacing={2}>
          <Text>
            {getMChatPerguntaNumber(pergunta)}. “{MCHAT_PERGUNTAS[pergunta]}”
            <Text component='span' fontWeight='bold' color='danger'>
              {' '}
              *
            </Text>
            {getListItemHasData(pergunta) && <ConsultaSeguimentoPerguntaSelectListItemStatus status='INFO' />}
          </Text>
          <Tooltip text={disabled ? disabledTooltipText : undefined}>
            <div>
              <Checkbox checked disabled={disabled} />
            </div>
          </Tooltip>
        </HFlow>
      ))}
    </VFlow>
  )
}

const createStyles = (theme: Theme) => ({
  list: css`
    & > div {
      border-bottom: 1px solid ${theme.pallete.divider};
      margin: 0;
      padding: 0.25rem 1rem;
      &:last-child {
        border-bottom: 0;
      }
    }
  `,
})
